import React, { useState, useEffect, useMemo } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { toast } from 'react-toastify';
import { API_COMPANY_CREATE, API_PARENT_COMPANY_LICENCE, API_MANAGE_LOCATIONS_LIST, API_MANAGE_GROUP_LISTING, API_CALL_STRATEGIES_MASTER_LIST, API_COMPANY_PROFILE, API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, API_ACL_SETTING_LIST, API_SIGNUP_EMAIL_SEND_CODE, API_SIGNUP_EMAIL_VERIFY_CODE } from '../../../service/url';
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from '../../../service/httpCall';
import { useNavigate } from 'react-router-dom';
import { ROUTES, USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '../../../utilities/constant';
import { getDefaultUserRolesForCompanyCreate } from '../../../utilities/defaultUserRolesCompanyCreate';
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import { validatePhone, validateEmail } from "../../../utilities/helpers";

import Select from 'react-select';
import { Storage } from "../../../utilities/setting";
import { FiPhone, FiUsers, FiActivity, FiShare2, FiSmartphone } from "react-icons/fi";
import { FaBuilding, FaHeadset } from "react-icons/fa";
import LicenceAllocationPanel from "../../../components/partials/dashboard/company/LicenceAllocationPanel";
import DefaultUserForm from "../../../components/partials/dashboard/company/DefaultUserForm";
import "../../../assets/custom/css/custom.css";

const CompanyCreate = () => {

  const navigate = useNavigate();

  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPincode, setCompanyPincode] = useState("");
  const [companyLicence, setCompanyLicence] = useState("");
  const [parentLicence, setParentLicence] = useState(null);
  const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [channel, setChannel] = useState(0);
  const [errors, setErrors] = useState({});
  const [availableLicence, setAvailableLicence] = useState({});
  const [asReseller, setAsReseller] = useState(0);
  const [asCompany, setAsCompany] = useState(0);
  const [loginUserRole, setLoginUserRole] = useState(null);
  const [locations, setLocations] = useState([]);
  const [callStrategies, setCallStrategies] = useState([]);
  const [selectedCallStrategy, setSelectedCallStrategy] = useState([]);
  const [countryCodeDirections, setCountryCodeDirections] = useState([]);
  const [selectedCountryCodeDirections, setSelectedCountryCodeDirections] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [isResellerCompany, setIsResellerCompany] = useState(null);
  const [isOwnCompany, setIsOwnCompany] = useState(null);
  const [resellerCreationBlocked, setResellerCreationBlocked] = useState(false);
  const [notes, setNotes] = useState([]);
  const [cps, setCps] = useState(0);
  const [mobile, setMobile] = useState(0);

  const [defaultUserName, setDefaultUserName] = useState("");
  const [defaultUsername, setDefaultUsername] = useState("");
  const [defaultUserEmail, setDefaultUserEmail] = useState("");
  const [defaultUserPassword, setDefaultUserPassword] = useState("");
  const [defaultUserConfirmPassword, setDefaultUserConfirmPassword] = useState("");
  const [defaultUserExpiryDate, setDefaultUserExpiryDate] = useState("");
  const [defaultUserAclList, setDefaultUserAclList] = useState([]);
  const [defaultUserAcl, setDefaultUserAcl] = useState("");
  const [parentExpiryDate, setParentExpiryDate] = useState(null);
  const [showDefaultPassword, setShowDefaultPassword] = useState(false);
  const [signupEmailOtp, setSignupEmailOtp] = useState("");
  const [signupEmailToken, setSignupEmailToken] = useState("");
  const [emailVerifiedForCreate, setEmailVerifiedForCreate] = useState(false);
  const [signupEmailBusy, setSignupEmailBusy] = useState(false);
  const [defaultUserRoleSelection, setDefaultUserRoleSelection] = useState("");
  const [defaultUserAccountType, setDefaultUserAccountType] = useState("0");
  const [isCreatorSuperAdmin, setIsCreatorSuperAdmin] = useState(false);
  const [isCreatorCompanyAdmin, setIsCreatorCompanyAdmin] = useState(false);
  const [creatorAssignedIsOwnCompany, setCreatorAssignedIsOwnCompany] = useState(false);
  const [isCreatorCallCenterAdmin, setIsCreatorCallCenterAdmin] = useState(false);
  const [isCreatorReseller, setIsCreatorReseller] = useState(false);
  const [resellerChainParentRole, setResellerChainParentRole] = useState("");
  const [resellerChainSuperParentRole, setResellerChainSuperParentRole] = useState("");
  const [resellerChainSuperSuperParentRole, setResellerChainSuperSuperParentRole] = useState("");

  const handleResellerChange = (checked) => {
    if (resellerCreationBlocked) {
      toast.error("Reseller chain limit reached. You can only create an End User.");
      return;
    }
    setIsResellerCompany(checked);
    setIsOwnCompany(false);
  };

  const handleOwnCompanyChange = (checked) => {
    setIsOwnCompany(checked);
    setIsResellerCompany(false);
  };



  // useEffect( () => {

  //    if(toastProps){
  //       setShowToast(true);
  //    }

  // }, [toastProps]);

  useEffect(() => {
    const fetchMetaData = async () => {
      const user = JSON.parse(Storage.getItem("user"));

      try {
        const [locationsData, groupsData, callStrategiesData, countryCodeDirectionsData] = await Promise.all([
          getApiCall(API_MANAGE_LOCATIONS_LIST, {}),
          getApiCall(API_MANAGE_GROUP_LISTING, {}),
          getApiCall(API_CALL_STRATEGIES_MASTER_LIST, {}),
          getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {}).catch(() => [])
        ]);

        setCallStrategies(callStrategiesData?.map(strategy => ({
          value: strategy.id,
          label: strategy.name
        })) || []);

        setCountryCodeDirections(Array.isArray(countryCodeDirectionsData) ? countryCodeDirectionsData : []);

        if (user.role === USER_ROLES.SUPERADMIN) {
          // Normalize API data -> always { value, label }
          const normalizedLocations =
            (locationsData || []).map(loc => ({
              value: loc.location_id,
              label: loc.location_name,
            })) || [];

          const normalizedGroups =
            (groupsData || []).map(g => ({
              value: g.group_id,
              label: g.group_name,
            })) || [];

          setLocations(normalizedLocations);
          setGroups(normalizedGroups);
        } else {
          // Normalize user-based data -> always { value, label }
          const userGroups =
            groupsData.map(ug => ({
              value: ug.group_id,
              label: ug.group_name,
            })) || [];
          const userLocations =
            locationsData?.map(ul => ({
              value: ul.location_id,
              label: ul.location_name,
            })) || [];

          setGroups(userGroups);
          setLocations(userLocations);
        }
      } catch (error) {
        console.error("Error fetching Dialer groups/locations:", error);
      }
    };
    fetchMetaData();

    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.COMPANY && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
      setNotes
    );
  }, []);

  useEffect(() => {
    getUser();
  }, []);

  const defaultUserRoleSelectOptions = useMemo(
    () =>
      getDefaultUserRolesForCompanyCreate({
        isSuperAdmin: isCreatorSuperAdmin,
        isCompanyAdmin: isCreatorCompanyAdmin,
        creatorAssignedIsOwnCompany,
        isCallCenterAdmin: isCreatorCallCenterAdmin,
        isReseller: isCreatorReseller,
        loggedUserParent: resellerChainParentRole,
        loggedUserSuperParent: resellerChainSuperParentRole,
        loggedUserSuperSuperParent: resellerChainSuperSuperParentRole,
        isCreatingResellerCompany: Boolean(isResellerCompany),
        isCreatingEndUserCompany: Boolean(isOwnCompany),
      }),
    [
      isCreatorSuperAdmin,
      isCreatorCompanyAdmin,
      creatorAssignedIsOwnCompany,
      isCreatorCallCenterAdmin,
      isCreatorReseller,
      resellerChainParentRole,
      resellerChainSuperParentRole,
      resellerChainSuperSuperParentRole,
      isResellerCompany,
      isOwnCompany,
    ]
  );

  useEffect(() => {
    const allowed = defaultUserRoleSelectOptions.map((o) => o.value);
    if (!allowed.length) {
      setDefaultUserRoleSelection("");
      return;
    }
    setDefaultUserRoleSelection((prev) => {
      if (prev && allowed.includes(prev)) return prev;
      if (isResellerCompany && allowed.includes(USER_ROLES.RESELLER)) {
        return USER_ROLES.RESELLER;
      }
      if (isOwnCompany && allowed.includes(USER_ROLES.COMPANY_ADMIN)) {
        return USER_ROLES.COMPANY_ADMIN;
      }
      return allowed[0];
    });
  }, [defaultUserRoleSelectOptions, isResellerCompany, isOwnCompany]);

  useEffect(() => {
    if (!defaultUserRoleSelection) {
      setDefaultUserAclList([]);
      setDefaultUserAcl("");
      return;
    }
    getApiCall(
      `${API_ACL_SETTING_LIST}?target_role=${encodeURIComponent(defaultUserRoleSelection)}`,
      {}
    )
      .then((list) => {
        setDefaultUserAclList(list || []);
        const defaultAcl = (list || []).find(
          (acl) => acl.default_for_role === defaultUserRoleSelection
        );
        if (defaultAcl) {
          setDefaultUserAcl(String(defaultAcl.id));
        } else {
          setDefaultUserAcl("");
        }
      })
      .catch((err) => console.error(err));
  }, [defaultUserRoleSelection]);

  useEffect(() => {
    getApiCall(API_PARENT_COMPANY_LICENCE).then((resp) => {
      setParentLicence(resp?.parentLicence);
    }).catch((error) => {
      toast.error(JSON.stringify(error));
    });
  }, []);

  const validateInput = (value, key) => {
    if (value === "" || value == null) {
      return 0;
    }
    const digitsOnly = String(value).replace(/\D/g, "");
    if (digitsOnly === "") {
      return 0;
    }
    const num = parseInt(digitsOnly, 10);
    let newErrors = { ...errors };

    if (Number.isNaN(num)) return 0;

    if (num < 0) {
      newErrors[key] = "Value cannot be negative";
      setErrors(newErrors);
      return 0;
    }

    const licenceKeyMap = {
      role_ccadmin: "role_ccadmin",
      agent: "role_ccagent",
      live_agent: "live_agent",
      channel: "channel",
        cps: "cps",
      mobile: "mobile",
      reseller: "reseller",
      company: "company",
    };

    const licenceKey = licenceKeyMap[key];
    const availableValue = parentLicence?.available_licence?.[licenceKey];

    if (availableValue === 0 && num > 0) {
      newErrors[key] = "Value cannot be more than 0";
      setErrors(newErrors);
      return num;
    }

    newErrors[key] = "";

    const nextAgent = key === "agent" ? num : agent;
    const nextLiveAgent = key === "live_agent" ? num : liveAgent;

    if (nextAgent < nextLiveAgent) {
      newErrors.agent = "Total Agent cannot be less than Live Agent";
      newErrors.live_agent = "Live Agent cannot be more than Total Agent";
    } else {
      newErrors.agent = "";
      newErrors.live_agent = "";
    }

    if (
      availableValue !== null &&
      availableValue !== undefined &&
      availableValue > 0
    ) {
      if (
        key === "company" &&
        num > availableValue - 1
      ) {
        newErrors.company = `Value cannot be more than ${availableValue - 1}`;
      }

      if (
        key !== "company" &&
        num > availableValue
      ) {
        newErrors[key] = `Value cannot be more than ${availableValue}`;
      }
    }

    if (key === "live_agent" && num > nextAgent) {
      newErrors.live_agent = `Live Agent cannot be more than Total Agent (${nextAgent})`;
    }

    setErrors(newErrors);
    return num;
  };

  const getLicenceMax = (key) => {
    const avail = parentLicence?.available_licence;
    if (avail == null) return undefined;
    const map = {
      role_ccadmin: avail.role_ccadmin,
      agent: avail.role_ccagent,
      live_agent: avail.live_agent,
      channel: avail.channel,
      cps: avail.cps,
      mobile: avail.mobile,
      company: avail.company,
    };
    const max = map[key];
    if (key === "company" && max != null && max > 0) {
      return max - 1;
    }
    return max;
  };

  const stepLicence = (key, current, setter, delta) => {
    const next = Math.max(0, current + delta);
    setter(validateInput(String(next), key));
  };

  const canIncrementLicence = (key, current) => {
    const max = getLicenceMax(key);
    if (max === undefined || max === null) return true;
    return current < max;
  };

  async function getUser() {
    try {
      const user = JSON.parse(Storage.getItem('user'));
      if (user) {
        setLoginUserRole(user.role);

        const isSa = user.role === USER_ROLES.SUPERADMIN;
        const isCa = user.role === USER_ROLES.COMPANY_ADMIN;
        const assignedOwn = Boolean(user?.assignedCompany?.is_own_company);
        const isCc = user.role === USER_ROLES.CALL_CENTRE_ADMIN;
        const isR = user.role === USER_ROLES.RESELLER;

        setIsCreatorSuperAdmin(isSa);
        setIsCreatorCompanyAdmin(isCa);
        setCreatorAssignedIsOwnCompany(assignedOwn);
        setIsCreatorCallCenterAdmin(isCc);
        setIsCreatorReseller(isR);

        if (isR) {
          setResellerChainParentRole(user.role || "");
          setResellerChainSuperParentRole(user?.createdByUser?.role ?? "");
          setResellerChainSuperSuperParentRole(
            user?.createdByUser?.createdByUser?.role ?? ""
          );
        } else {
          setResellerChainParentRole("");
          setResellerChainSuperParentRole("");
          setResellerChainSuperSuperParentRole("");
        }

        if (user.expiry_date) {
          setParentExpiryDate(user.expiry_date);
        }
        const myCompany = user.assignedCompany;
        const parentUser = user.createdByUser;
        let parentCompany = null;
        if (parentUser) {
          if (parentUser.assigned_company) {
            const urlToFetch = API_COMPANY_PROFILE.replace(":id", parentUser.assigned_company);
            parentCompany = await getApiCall(urlToFetch);
          }
        }

        let resellerDepth = 0;

        if (myCompany?.is_reseller_company) resellerDepth++;
        if (parentCompany?.is_reseller_company) resellerDepth++;

        if (resellerDepth >= 2) {
          setResellerCreationBlocked(true);
          setIsResellerCompany(false);
          if (user.role !== USER_ROLES.SUPERADMIN) {
            setIsOwnCompany(true);
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }


  function validateCompanyFields() {
    let valid = true;

    if (!companyName.trim()) {
      valid = false;
      toast.error("Company name required");
    } else if (!companyPhone.trim()) {
      valid = false;
      toast.error("Company phone required");
    } else if (!validateCompanyPhone(companyPhone)) {
      valid = false;
      //  setToastProps({
      //      message: "Company phone invalid format",
      //      type: "danger",
      toast.error("Company phone invalid format");
    } else if (!companyPincode.trim()) {
      valid = false;
      toast.error("Company pincode required");
    } else if (!/^\d{6}$/.test(companyPincode)) {
      valid = false;
      toast.error("Company pincode must be exactly 6 digits");
    } else if (!companyAddress.trim()) {
      valid = false;
      toast.error("Company address required");
    }
    if (!isResellerCompany && !isOwnCompany) {
      toast.error("Please select either Reseller Company or End User");
      return false;
    }
    return valid;
  }

  function validateDefaultUserFields() {
    let valid = true;
    if (!defaultUserName.trim()) {
      valid = false;
      toast.error("Default user name is required");
    }
    if (!defaultUsername.trim() || defaultUsername.trim().length < 3) {
      valid = false;
      toast.error("Default user username is required (min 3 characters)");
    }
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      valid = false;
      toast.error("Valid default user email is required");
    }
    if (!defaultUserPassword.trim() || defaultUserPassword.length < 8) {
      valid = false;
      toast.error("Default user password is required (min 8 characters)");
    }
    if (defaultUserPassword !== defaultUserConfirmPassword) {
      valid = false;
      toast.error("Default user passwords do not match");
    }
    if (!defaultUserExpiryDate) {
      valid = false;
      toast.error("Default user expiry date is required");
    } else if (parentExpiryDate) {
      const child = new Date(defaultUserExpiryDate);
      const parent = new Date(parentExpiryDate);
      child.setHours(0, 0, 0, 0);
      parent.setHours(0, 0, 0, 0);
      if (child > parent) {
        valid = false;
        toast.error("Default user expiry cannot exceed parent expiry date");
      }
    }
    if (!defaultUserRoleSelection) {
      valid = false;
      toast.error("Select a role for the default user");
    }
    if (!defaultUserAcl) {
      valid = false;
      toast.error("Default user ACL is required");
    }
    if (!emailVerifiedForCreate || !signupEmailToken) {
      valid = false;
      toast.error("Verify the default user email: use Send code, enter the OTP, then click Verify OTP.");
    }
    if (isCreatorSuperAdmin) {
      if (
        defaultUserAccountType === "" ||
        defaultUserAccountType === null ||
        defaultUserAccountType === undefined
      ) {
        valid = false;
        toast.error("Default user account type is required");
      } else if (![0, 1].includes(Number(defaultUserAccountType))) {
        valid = false;
        toast.error("Account Type must be Promotional or Transactional");
      }
    }
    return valid;
  }

  const handleDefaultUserEmailChange = (e) => {
    setDefaultUserEmail(e.target.value);
    setSignupEmailToken("");
    setSignupEmailOtp("");
    setEmailVerifiedForCreate(false);
  };

  const sendDefaultUserSignupEmailCode = async () => {
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      toast.error("Enter a valid email before sending a code.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, { email: defaultUserEmail.trim() });
      setSignupEmailToken("");
      setEmailVerifiedForCreate(false);
      toast.success("Verification code sent. Check the inbox for this email.");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Could not send verification code");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  const verifyDefaultUserSignupEmailOtp = async () => {
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      toast.error("Enter a valid email.");
      return;
    }
    if (!signupEmailOtp || signupEmailOtp.length !== 6) {
      toast.error("Enter the 6-digit code from the email.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
        email: defaultUserEmail.trim(),
        otp: signupEmailOtp.trim(),
      });
      if (data?.signupEmailToken) {
        setSignupEmailToken(data.signupEmailToken);
        setEmailVerifiedForCreate(true);
        toast.success("Email verified. You can submit the form to create the company.");
      } else {
        toast.error("Unexpected response from server");
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Verification failed");
      setEmailVerifiedForCreate(false);
      setSignupEmailToken("");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  function validateCompanyPhone(phone) {
    if (!phone) return false;
    return /^[0-9]{10}$/.test(phone.trim());
  }

  async function submitForm() {
    setButtonDisable(true);

    if (!validateCompanyFields()) {
      setButtonDisable(false);
      return;
    }

    if (!validateDefaultUserFields()) {
      setButtonDisable(false);
      return;
    }

    if (resellerCreationBlocked && isResellerCompany) {
      toast.error("You are not allowed to create a Reseller Company. Please create an End User.");
      setButtonDisable(false);
      return;
    }

    if (liveAgent > agent) {
      toast.error("Live Agent cannot exceed Total Agents");
      setButtonDisable(false);
      return;
    }

    // Add this new validation check for available licences
    if (Object.values(errors).some(error => error !== "")) {
      toast.error("Please fix all validation errors before submitting");
      setButtonDisable(false);
      return;
    }

    const params = {
      name: companyName,
      phone: companyPhone,
      address: companyAddress,
      pincode: companyPincode,
      is_reseller_company: isResellerCompany,
      is_own_company: isOwnCompany,
      licence: {
        role_ccadmin: callCenterAdminTeamlead,
        role_ccagent: agent,
        live_agent: liveAgent,
        channel: channel,
         cps: cps,
        mobile: mobile,
        reseller: 0, // use asReseller when reseller box uncommented
        company: isOwnCompany ? 0 : asCompany,
      },
      
    }

    if (selectedGroup && selectedGroup.length > 0) {
      params.groups = Array.isArray(selectedGroup)
        ? selectedGroup.map(Number)
        : [Number(selectedGroup)];
    }

    if (selectedLocation && selectedLocation.length > 0) {
      params.locations = Array.isArray(selectedLocation)
        ? selectedLocation.map(Number)
        : [Number(selectedLocation)];
    }
    if (selectedCallStrategy && selectedCallStrategy.length > 0) {
      params.call_strategies = Array.isArray(selectedCallStrategy)
        ? selectedCallStrategy.map(Number)
        : [Number(selectedCallStrategy)];
    }
    if (selectedCountryCodeDirections && selectedCountryCodeDirections.length > 0) {
      params.country_code_directions = Array.isArray(selectedCountryCodeDirections)
        ? selectedCountryCodeDirections.map(Number)
        : [Number(selectedCountryCodeDirections)];
    }

    params.default_user = {
      name: defaultUserName.trim(),
      username: defaultUsername.trim(),
      email: defaultUserEmail.trim(),
      password: defaultUserPassword,
      expiry_date: defaultUserExpiryDate,
      acl_settings: defaultUserAcl,
      signup_email_token: signupEmailToken,
      role: defaultUserRoleSelection,
    };

    if (isCreatorSuperAdmin) {
      params.default_user.account_type = Number(defaultUserAccountType);
    }

    postApiCall(API_COMPANY_CREATE, params)
      .then(onCreateCreateSuccess)
      .catch(onError);
  }


  function onCreateCreateSuccess(resp) {
    toast.success("Company and default user created successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.COMPANIES.LIST}`);
    }, 1500);
  }

  function onError(err) {
    setButtonDisable(false);
    console.log(err);
    toast.error(JSON.stringify(err));
  }

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">New Company Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info company-create-form">
                  <form>
                    {RenderUserCompanyFields({
                      company_name: companyName,
                      set_company_name: setCompanyName,
                      company_phone: companyPhone,
                      set_company_phone: setCompanyPhone,
                      company_address: companyAddress,
                      set_company_address: setCompanyAddress,
                      company_pincode: companyPincode,
                      set_company_pincode: setCompanyPincode,
                      locations,
                      selectedLocation,
                      setSelectedLocation,
                      countryCodeDirections,
                      selectedCountryCodeDirections,
                      setSelectedCountryCodeDirections,
                    })}

                    <div className="row g-3 mt-1">
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>Call Strategy</Form.Label>
                        <div className="ccf-input-with-icon">
                          <span className="ccf-input-with-icon__icon">
                            <FiPhone size={18} />
                          </span>
                          <Select
                            className="theme-react-select ccf-select-in-icon"
                            classNamePrefix="theme-react-select"
                            options={callStrategies}
                            value={callStrategies.filter((l) =>
                              selectedCallStrategy.includes(l.value)
                            )}
                            onChange={(selected) =>
                              setSelectedCallStrategy(selected.map((s) => s.value))
                            }
                            isMulti
                            placeholder="Select Call Strategy"
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>Dialer Group</Form.Label>
                        <div className="ccf-input-with-icon">
                          <span className="ccf-input-with-icon__icon">
                            <FiUsers size={18} />
                          </span>
                          <Select
                            className="theme-react-select ccf-select-in-icon"
                            classNamePrefix="theme-react-select"
                            options={groups}
                            value={groups.filter((g) => selectedGroup.includes(g.value))}
                            onChange={(selected) =>
                              setSelectedGroup(selected.map((s) => s.value))
                            }
                            isMulti
                            placeholder="Select Dialer Group"
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="company-type-section-v2 mt-3">
                      <Form.Label className="ccf-field-label d-block">
                        Company type <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="row g-3">
                        {!resellerCreationBlocked && (
                          <div className="col-12 col-md-6">
                            <div
                              role="button"
                              tabIndex={0}
                              className={`company-type-card-v2 ${isResellerCompany ? "is-selected" : ""}`}
                              onClick={() => handleResellerChange(true)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  handleResellerChange(true);
                                }
                              }}
                            >
                              <span className="company-type-card-v2__radio" aria-hidden="true" />
                              <span className="company-type-card-v2__icon company-type-card-v2__icon--reseller">
                                <FaBuilding size={20} />
                              </span>
                              <div className="company-type-card-v2__body">
                                <div className="company-type-card-v2__title">Reseller Company</div>
                                <div className="company-type-card-v2__desc">
                                  Can create and manage child companies
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className={resellerCreationBlocked ? "col-12" : "col-12 col-md-6"}>
                          <div
                            role="button"
                            tabIndex={0}
                            className={`company-type-card-v2 ${isOwnCompany ? "is-selected" : ""}`}
                            onClick={() => handleOwnCompanyChange(true)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleOwnCompanyChange(true);
                              }
                            }}
                          >
                            <span className="company-type-card-v2__radio" aria-hidden="true" />
                            <span className="company-type-card-v2__icon company-type-card-v2__icon--enduser">
                              <FiUsers size={22} />
                            </span>
                            <div className="company-type-card-v2__body">
                              <div className="company-type-card-v2__title">End User</div>
                              <div className="company-type-card-v2__desc">
                                Operates as a single end-user company
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {(isResellerCompany || isOwnCompany) && (
                    <LicenceAllocationPanel
                      showNote={!isOwnCompany}
                      noteMessage={
                        notes.find((n) => Number(n.priority) === 1)?.message ??
                        "One Company Licence is automatically used for the newly created company."
                      }
                      footerNote={
                        loginUserRole !== USER_ROLES.SUPERADMIN
                          ? notes.find((n) => Number(n.priority) === 2)?.message ?? ""
                          : ""
                      }
                      columns={[
                        {
                          key: "role_ccadmin",
                          icon: FaHeadset,
                          iconModifier: "callcenter",
                          title: "Call Centers",
                          description: "Number of call centers",
                          value: parseInt(String(callCenterAdminTeamlead), 10) || 0,
                          onChange: (val) =>
                            setCallCenterAdminTeamlead(validateInput(String(val), "role_ccadmin")),
                          onDecrement: () =>
                            stepLicence("role_ccadmin", callCenterAdminTeamlead, setCallCenterAdminTeamlead, -1),
                          onIncrement: () =>
                            stepLicence("role_ccadmin", callCenterAdminTeamlead, setCallCenterAdminTeamlead, 1),
                          disabledMinus: (parseInt(String(callCenterAdminTeamlead), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("role_ccadmin", parseInt(String(callCenterAdminTeamlead), 10) || 0),
                          error: errors.role_ccadmin,
                        },
                        {
                          key: "agent",
                          icon: FiUsers,
                          iconModifier: "agent",
                          title: "Total Agent",
                          description: "Total number of agents",
                          value: parseInt(String(agent), 10) || 0,
                          onChange: (val) => setAgent(validateInput(String(val), "agent")),
                          onDecrement: () => stepLicence("agent", agent, setAgent, -1),
                          onIncrement: () => stepLicence("agent", agent, setAgent, 1),
                          disabledMinus: (parseInt(String(agent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("agent", parseInt(String(agent), 10) || 0),
                          error: errors.agent,
                        },
                        {
                          key: "live_agent",
                          icon: FiActivity,
                          iconModifier: "live",
                          title: "Live Agent",
                          description: "Agents for live calls",
                          value: parseInt(String(liveAgent), 10) || 0,
                          onChange: (val) => setLiveAgent(validateInput(String(val), "live_agent")),
                          onDecrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, -1),
                          onIncrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, 1),
                          disabledMinus: (parseInt(String(liveAgent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("live_agent", parseInt(String(liveAgent), 10) || 0),
                          error: errors.live_agent,
                        },
                        {
                          key: "channel",
                          icon: FiShare2,
                          iconModifier: "channel",
                          title: "Channels",
                          description: "Communication channels",
                          value: parseInt(String(channel), 10) || 0,
                          onChange: (val) => setChannel(validateInput(String(val), "channel")),
                          onDecrement: () => stepLicence("channel", channel, setChannel, -1),
                          onIncrement: () => stepLicence("channel", channel, setChannel, 1),
                          disabledMinus: (parseInt(String(channel), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("channel", parseInt(String(channel), 10) || 0),
                          error: errors.channel,
                        },
                        {
                          key: "cps",
                          icon: FiPhone,
                          iconModifier: "channel",
                          title: "CPS",
                          description: "Calls per second",
                          value: parseInt(String(cps), 10) || 0,
                          onChange: (val) => setCps(validateInput(String(val), "cps")),
                          onDecrement: () => stepLicence("cps", cps, setCps, -1),
                          onIncrement: () => stepLicence("cps", cps, setCps, 1),
                          disabledMinus: (parseInt(String(cps), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("cps", parseInt(String(cps), 10) || 0),
                          error: errors.cps,
                        },
                        {
                          key: "mobile",
                          icon: FiSmartphone,
                          iconModifier: "mobile",
                          title: "Mobile License",
                          description: "Mobile dialer licences",
                          value: parseInt(String(mobile), 10) || 0,
                          onChange: (val) => setMobile(validateInput(String(val), "mobile")),
                          onDecrement: () => stepLicence("mobile", mobile, setMobile, -1),
                          onIncrement: () => stepLicence("mobile", mobile, setMobile, 1),
                          disabledMinus: (parseInt(String(mobile), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("mobile", parseInt(String(mobile), 10) || 0),
                          error: errors.mobile,
                        },
                        {
                          key: "company",
                          icon: FaBuilding,
                          iconModifier: "company",
                          title: "Company",
                          description: "Additional companies",
                          value: parseInt(String(asCompany), 10) || 0,
                          hidden: isOwnCompany,
                          onChange: (val) => setAsCompany(validateInput(String(val), "company")),
                          onDecrement: () => stepLicence("company", asCompany, setAsCompany, -1),
                          onIncrement: () => stepLicence("company", asCompany, setAsCompany, 1),
                          disabledMinus: (parseInt(String(asCompany), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence("company", parseInt(String(asCompany), 10) || 0),
                          error: errors.company,
                        },
                      ]}
                      availableSummary={
                        loginUserRole !== USER_ROLES.SUPERADMIN ? (
                          <div className="licence-available-summary">
                            <h6 className="licence-available-summary__title">
                              Available Licence (Allocated Company)
                            </h6>
                            <div className="licence-available-summary__row">
                              <span>Call Centers: {parentLicence?.available_licence?.role_ccadmin ?? 0}</span>
                              <span>Agent: {parentLicence?.available_licence?.role_ccagent ?? 0}</span>
                              <span>Live Agent: {parentLicence?.available_licence?.live_agent ?? 0}</span>
                              <span>Channels: {parentLicence?.available_licence?.channel ?? 0}</span>
                              <span>CPS: {parentLicence?.available_licence?.cps ?? 0}</span>
                              <span>Mobile: {parentLicence?.available_licence?.mobile ?? 0}</span>
                              {!isOwnCompany && (
                                <span>Company: {parentLicence?.available_licence?.company ?? 0}</span>
                              )}
                            </div>
                          </div>
                        ) : null
                      }
                    />
                    )}

                    {(isResellerCompany || isOwnCompany) && (
                      <DefaultUserForm
                        isResellerCompany={isResellerCompany}
                        name={defaultUserName}
                        setName={setDefaultUserName}
                        username={defaultUsername}
                        setUsername={setDefaultUsername}
                        email={defaultUserEmail}
                        onEmailChange={handleDefaultUserEmailChange}
                        expiryDate={defaultUserExpiryDate}
                        setExpiryDate={setDefaultUserExpiryDate}
                        password={defaultUserPassword}
                        setPassword={setDefaultUserPassword}
                        confirmPassword={defaultUserConfirmPassword}
                        setConfirmPassword={setDefaultUserConfirmPassword}
                        showPassword={showDefaultPassword}
                        setShowPassword={setShowDefaultPassword}
                        aclValue={defaultUserAcl}
                        setAclValue={setDefaultUserAcl}
                        aclList={defaultUserAclList}
                        roleValue={defaultUserRoleSelection}
                        setRoleValue={setDefaultUserRoleSelection}
                        roleOptions={defaultUserRoleSelectOptions}
                        signupEmailOtp={signupEmailOtp}
                        setSignupEmailOtp={setSignupEmailOtp}
                        emailVerified={emailVerifiedForCreate}
                        signupEmailBusy={signupEmailBusy}
                        onSendCode={sendDefaultUserSignupEmailCode}
                        onVerifyOtp={verifyDefaultUserSignupEmailOtp}
                        showAccountType={isCreatorSuperAdmin}
                        accountType={defaultUserAccountType}
                        setAccountType={setDefaultUserAccountType}
                      />
                    )}

                    <div className="form-actions">
                    <Button
                      onClick={submitForm}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable || Object.values(errors).some(error => error !== "") || !(isResellerCompany || isOwnCompany)}
                    ><FaBuilding className="me-2" /> Create Company &amp; Default User &nbsp;
                      {
                        buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                      }
                    </Button>
                    </div>

                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

    </>
  )

}

export default CompanyCreate;
